// extracted by mini-css-extract-plugin
export var container = "projects-module--container--9nmaH";
export var textContainer = "projects-module--textContainer--3m5MA";
export var topTop = "projects-module--topTop--fG0c0";